import styled from '@emotion/styled'
import { breakpoints, colors, fonts, fontSizes } from 'src/utils/styles'

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 1.45rem 0 0;
  margin: 1em 4.1rem 0 0;
  align-items: baseline;

  @media (max-width: ${breakpoints.xxl}px) {
    margin: 1em 2.1rem -1.8em 0;
  }

  @media (max-width: ${breakpoints.l}px) {
    margin: 1em 0.1rem 0 0;
  }

  @media (max-width: ${breakpoints.s}px) {
    align-items: stretch;
    flex-direction: column;
    padding: 0;
    margin: 0;
  }
`

export const Headline = styled.h1`
  font-size: ${fontSizes.allProductsDesktop};
  font-family: ${fonts.extendedBold};
  margin-bottom: 0;
  margin-top: 0;
  z-index: 0;

  @media (max-width: ${breakpoints.xl}px) {
    font-size: ${fontSizes.allProductsiPad};
  }

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.allProductsMobile};
  }
`

export const TotalProducts = styled.span`
  font-size: ${fontSizes.totalProducts};
  font-family: ${fonts.regular};
  display: initial;
  font-weight: normal;

  @media (max-width: ${breakpoints.s}px) {
    display: none;
  }
`

export const SortContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  flex-wrap: wrap;

  @media (max-width: ${breakpoints.s}px) {
    flex-direction: column;
  }
`

export const TopContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  @media (max-width: ${breakpoints.s}px) {
    margin-top: -0.75em;
  }
`

export const InnerContainer = styled.div`
  display: flex;
  align-items: baseline;
  flex-direction: row;
`

export const ActiveFilters = styled.div`
  display: none;

  @media (max-width: ${breakpoints.s}px) {
    display: block;
  }
`

export const ActiveFiltersTablet = styled.div`
  display: none;

  @media (max-width: ${breakpoints.l}px) {
    display: block;
  }
  @media (max-width: ${breakpoints.s}px) {
    display: none;
  }
`

export const Filters = styled.div`
  font-family: ${fonts.regular};
  text-transform: none;
  font-size: 1rem;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  width: 100%;

  @media (max-width: ${breakpoints.s}px) {
    margin-bottom: 0;
  }
`

export const ProductsWrapper = styled.div`
  margin: 0 20px 0 75px;

  @media (max-width: ${breakpoints.l}px) {
    margin: 0 0 0 50px;
    padding: 0;
    position: ${props => (props.isFixed ? 'fixed' : 'unset')};
    z-index: ${props => (props.isFixed ? '99' : 'unset')};
  }

  @media (max-width: ${breakpoints.s}px) {
    margin: 0 20px;
    padding: 0;
    position: ${props => (props.isFixed ? 'fixed' : 'unset')};
    z-index: ${props => (props.isFixed ? '99' : 'unset')};
  }
`

export const StTabletFilterButton = styled.div`
  display: none;

  @media (max-width: ${breakpoints.l}px) {
    position: absolute;
    top: -28px;
    display: block;
  }
`

export const StFilterAmount = styled.span`
  border-radius: 50%;
  background-color: ${colors.lemonadeYellow};
  color: ${colors.darkGrayNoInverter};
  width: 19px;
  height: 19px;
  text-align: center;
  margin-left: auto;
  font-size: 11px;
  line-height: 17px;
  font-family: ${fonts.bold};
  margin-top: auto;
`
